import { render, staticRenderFns } from "./Disable.vue?vue&type=template&id=0ccd9e43&scoped=true"
import script from "./Disable.vue?vue&type=script&lang=js"
export * from "./Disable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccd9e43",
  null
  
)

export default component.exports